export default __webpack_public_path__ + "static/media/visa_card_bg.c23341ea.svg";